/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Automation_TitleInputs */

const cs_settings_automation_title = /** @type {(inputs: Settings_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatizace`)
};

const en_settings_automation_title = /** @type {(inputs: Settings_Automation_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automation`)
};

/**
* | output |
* | --- |
* | "Automation" |
*
* @param {Settings_Automation_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_automation_title = /** @type {((inputs?: Settings_Automation_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Automation_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_automation_title(inputs)
	return cs_settings_automation_title(inputs)
});